import { Link } from "react-router-dom";

/**
 * Simple Apple-style breadcrumb.
 * items = [{ label, to }]  — last item is rendered as current (no link).
 */
export default function Breadcrumb({ items = [] }) {
  return (
    <nav className="crumbs" aria-label="Breadcrumb" data-testid="breadcrumb">
      {items.map((it, i) => {
        const isLast = i === items.length - 1;
        return (
          <span key={i}>
            {isLast ? (
              <span className="text-[#1d1d1f]" data-testid={`breadcrumb-current`}>{it.label}</span>
            ) : (
              <Link to={it.to} data-testid={`breadcrumb-${i}`}>{it.label}</Link>
            )}
            {!isLast && <span className="sep">/</span>}
          </span>
        );
      })}
    </nav>
  );
}
